const carouselImages = [
  {
    url: '/WorkoutCarousel1.png',
    alt:"Workout Search",
    text:"Search for a Workout",
    tag: '/workouts'
  },
  {
    url: '/WorkoutCarousel2.png',
    alt:"Food Search",
    text:"Search for a Food",
    tag: '/meals'
  },
  {
    url: '/WorkoutCarousel3.png',
    alt:"Sign-Up, Sign-In",
    text:"Sign-in or Sign-up",
    tag: '/login'
  }
]

export {carouselImages}